var PartnerOverview = /** @class */ (function () {
    function PartnerOverview(useCases, actions, clientActions) {
        this.useCases = useCases;
        this.actions = actions;
        this.clientActions = clientActions;
    }
    PartnerOverview.prototype.initSummaryLoader = function () {
        this.actions.partnerSummary.loader("partnerSummaryReducer");
    };
    PartnerOverview.prototype.getPartnerSearchAction = function (req, searchData) {
        var _this = this;
        this.actions.partnerSummary.loader("partnerSummaryReducer");
        this.useCases.partnerAccountCodes.execute({
            onSuccess: function (data) {
                var _a;
                if (data &&
                    (data === null || data === void 0 ? void 0 : data.partnerAccounts) &&
                    ((_a = data === null || data === void 0 ? void 0 : data.partnerAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    searchData.parentAccountCode = searchData.accountCode;
                    searchData.accountCode = data === null || data === void 0 ? void 0 : data.partnerAccounts[0].partnerCode;
                    searchData.flag = data === null || data === void 0 ? void 0 : data.partnerAccounts[0].flag;
                    _this.actions.partnerSummary.clearSelectedDropdown(true, "partnerSummaryReducer");
                    _this.actions.partnerSummary.setPartnerAccounts(data.partnerAccounts, "partnerSummaryReducer");
                    _this.actions.partnerSummary.stopLoader("partnerSummaryReducer");
                }
                localStorage.setItem("client360SelectedClient", JSON.stringify(searchData));
                _this.actions.partnerSummary.setSelectedPartner(searchData, "partnerSummaryReducer");
            },
            onError: function (error) {
                _this.actions.partnerSummary.setError({ isOpen: true, error: error }, "partnerSummaryReducer");
                _this.actions.partnerSummary.stopLoader("partnerSummaryReducer");
            },
        }, req);
    };
    PartnerOverview.prototype.setSelectedPartner = function (searchData, skip) {
        if (skip) {
        }
        else {
            localStorage.setItem("client360SelectedClient", JSON.stringify(searchData));
        }
        this.actions.partnerSummary.setSelectedPartner(searchData, "partnerSummaryReducer");
    };
    PartnerOverview.prototype.getPartnerRevenueSummary = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.partnerRevenueSummary.execute({
                onSuccess: function (data) {
                    _this.actions.partnerSummary.setPartnerRevenueSummary(data, "partnerSummaryReducer");
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    PartnerOverview.prototype.getPartnerClientsSummary = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.partnerClientSummary.execute({
                onSuccess: function (data) {
                    _this.actions.partnerSummary.setPartnerClientSummary(data, "partnerSummaryReducer");
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    PartnerOverview.prototype.clearALLStoreData = function () {
        this.actions.partnerSummary.setPartnerAccounts([], "partnerSummaryReducer");
        this.actions.partnerSummary.setSelectedPartner(null, "partnerSummaryReducer");
    };
    PartnerOverview.prototype.setPartnerLoaderStop = function () {
        this.actions.partnerSummary.stopLoader("partnerSummaryReducer");
    };
    PartnerOverview.prototype.getPartnerAccountCodes = function (req) {
        var _this = this;
        this.actions.partnerSummary.loader("partnerSummaryReducer");
        this.useCases.partnerAccountCodes.execute({
            onSuccess: function (data) {
                _this.actions.partnerSummary.setPartnerAccounts(data.partnerAccounts, "partnerSummaryReducer");
                _this.actions.partnerSummary.stopLoader("partnerSummaryReducer");
            },
            onError: function (error) {
                _this.actions.partnerSummary.setError({ isOpen: true, error: error }, "partnerSummaryReducer");
                _this.actions.partnerSummary.stopLoader("partnerSummaryReducer");
            },
        }, req);
    };
    PartnerOverview.prototype.getPartnerProfDemMetNomSegDetails = function (req) {
        var _this = this;
        this.actions.partnerProfDemMetNomSeg.loader("partnerProfDemMetNomSeg");
        return new Promise(function (resolve, reject) {
            _this.useCases.profileDemMetNomSegDetails.execute({
                onSuccess: function (data) {
                    _this.actions.partnerProfDemMetNomSeg.getPartnerProfDemMetNomSegData(data, "partnerProfDemMetNomSeg");
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.partnerProfDemMetNomSeg.setError({ isOpen: true, error: error }, "partnerProfDemMetNomSeg");
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    reject(error);
                },
            }, req);
        });
    };
    PartnerOverview.prototype.getPartnerBankDetails = function (req) {
        var _this = this;
        this.actions.partnerProfDemMetNomSeg.loader("partnerProfDemMetNomSeg");
        return new Promise(function (resolve, reject) {
            _this.useCases.bankDetails.execute({
                onSuccess: function (data) {
                    _this.actions.partnerProfDemMetNomSeg.setBankData(data, "partnerProfDemMetNomSeg");
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    reject(error);
                },
            }, req);
        });
    };
    PartnerOverview.prototype.getPartnerRegistrationDetails = function (req) {
        var _this = this;
        this.actions.partnerProfDemMetNomSeg.loader("partnerProfDemMetNomSeg");
        return new Promise(function (resolve, reject) {
            _this.useCases.registrationDetails.execute({
                onSuccess: function (data) {
                    _this.actions.partnerProfDemMetNomSeg.setRegisData(data, "partnerProfDemMetNomSeg");
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    reject(error);
                },
            }, req);
        });
    };
    PartnerOverview.prototype.getPartnerCertificationDetails = function (req) {
        var _this = this;
        this.actions.partnerProfDemMetNomSeg.loader("partnerProfDemMetNomSeg");
        return new Promise(function (resolve, reject) {
            _this.useCases.certification.execute({
                onSuccess: function (data) {
                    _this.actions.partnerProfDemMetNomSeg.setCertificationData(data, "partnerProfDemMetNomSeg");
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.partnerProfDemMetNomSeg.stopLoader("partnerProfDemMetNomSeg");
                    reject(error);
                },
            }, req);
        });
    };
    return PartnerOverview;
}());
export default PartnerOverview;
